import React from "react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * ProfileCard — top-of-Settings identity chip. Renders the user's avatar,
 * display name, and email. Kept intentionally simple: no editing, no
 * mutations. Sign-out lives at the bottom of the page.
 */
export default function ProfileCard() {
  const { user } = useAuth();
  if (!user) return null;
  return (
    <div
      className="bg-white rounded-3xl border border-[#E8E5DF] p-5 flex items-center gap-4"
      data-testid="settings-profile"
    >
      {user.picture && (
        <img src={user.picture} alt="" className="w-12 h-12 rounded-full object-cover" />
      )}
      <div className="min-w-0 flex-1">
        <p className="font-display text-xl text-leaf-ink leading-tight truncate">{user.name}</p>
        <p className="text-xs text-leaf-mist truncate">{user.email}</p>
      </div>
    </div>
  );
}
